export const categories = [
  { slug: 'love', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-fire-line' },
  { slug: 'suspense', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-movie-line' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line' },
  { slug: 'school', name: '校园', icon: 'ri-building-line' },
];

export const comics = [
  {
    id: 1,
    title: '她的私密花园',
    author: '金智恩',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20cover%20featuring%20a%20young%20woman%20with%20flowing%20dark%20hair%20standing%20in%20a%20lush%20secret%20garden%20filled%20with%20blooming%20flowers%20and%20soft%20sunlight%2C%20romantic%20atmosphere%2C%20soft%20pastel%20color%20palette%2C%20Korean%20webtoon%20art%20style%2C%20delicate%20linework%2C%20dreamy%20aesthetic&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: 'love',
    description: '一个关于青春与初恋的甜蜜故事。当校园里最受欢迎的学长遇见了内向安静的女主角，一段充满心动与感动的浪漫故事就此展开。在秘密花园里，两颗心慢慢靠近，共同书写属于他们的青春篇章。',
    tags: ['恋爱', '校园', '甜宠', '青春'],
    rating: 4.8,
    views: 1285000,
    status: '连载中' as const,
    updateDate: '2026-08-05',
    chapters: [
      { id: 1, title: '第1话 相遇', date: '2025-03-15' },
      { id: 2, title: '第2话 心跳', date: '2025-03-22' },
      { id: 3, title: '第3话 秘密', date: '2025-03-29' },
      { id: 4, title: '第4话 告白', date: '2025-04-05' },
      { id: 5, title: '第5话 初吻', date: '2025-04-12' },
      { id: 6, title: '第6话 约会', date: '2025-04-19' },
      { id: 7, title: '第7话 误会', date: '2025-04-26' },
      { id: 8, title: '第8话 和解', date: '2025-05-03' },
      { id: 9, title: '第9话 旅行', date: '2025-05-10' },
      { id: 10, title: '第10话 未来', date: '2025-05-17' },
    ],
  },
  {
    id: 2,
    title: '剑与魔法之书',
    author: '李东旭',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20fantasy%20cover%20illustration%20featuring%20a%20heroic%20warrior%20holding%20a%20glowing%20sword%20with%20magical%20runes%20in%20an%20ancient%20castle%20setting%2C%20epic%20fantasy%20atmosphere%2C%20dramatic%20lighting%2C%20Korean%20webtoon%20art%20style%2C%20detailed%20armor%20design%2C%20mystical%20energy%20effects&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: 'fantasy',
    description: '在一个被魔法与剑统治的世界里，一位平凡的少年意外获得了传说中的魔法书。从此踏上了成为最强魔法剑士的冒险之旅。命运之轮开始转动，黑暗势力蠢蠢欲动，少年能否守护他所珍视的一切？',
    tags: ['奇幻', '冒险', '魔法', '战斗'],
    rating: 4.9,
    views: 2150000,
    status: '连载中' as const,
    updateDate: '2026-08-04',
    chapters: [
      { id: 1, title: '第1话 魔法书', date: '2024-06-01' },
      { id: 2, title: '第2话 觉醒', date: '2024-06-08' },
      { id: 3, title: '第3话 历练', date: '2024-06-15' },
      { id: 4, title: '第4话 伙伴', date: '2024-06-22' },
      { id: 5, title: '第5话 试炼', date: '2024-06-29' },
      { id: 6, title: '第6话 黑暗', date: '2024-07-06' },
      { id: 7, title: '第7话 决战', date: '2024-07-13' },
      { id: 8, title: '第8话 胜利', date: '2024-07-20' },
    ],
  },
  {
    id: 3,
    title: '都市猎人传说',
    author: '朴志浩',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20action%20cover%20illustration%20of%20a%20mysterious%20hunter%20in%20a%20black%20trench%20coat%20standing%20on%20a%20rainy%20city%20rooftop%20at%20night%2C%20neon%20cityscape%20background%2C%20noir%20atmosphere%2C%20Korean%20webtoon%20art%20style%2C%20sharp%20contrast%20lighting%2C%20cinematic%20composition&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: 'action',
    description: '夜幕降临，隐藏在都市阴影中的猎人们开始行动。他们追捕着危害人间的怪物与恶灵，守护着平凡人的日常。每一个黑夜都是一场生死较量，而这一次，猎人们将面对前所未有的强大敌人。',
    tags: ['动作', '都市', '猎人', '热血'],
    rating: 4.7,
    views: 1890000,
    status: '已完结' as const,
    updateDate: '2026-07-20',
    chapters: [
      { id: 1, title: '第1话 黑夜', date: '2023-08-10' },
      { id: 2, title: '第2话 猎物', date: '2023-08-17' },
      { id: 3, title: '第3话 追踪', date: '2023-08-24' },
      { id: 4, title: '第4话 对决', date: '2023-08-31' },
      { id: 5, title: '第5话 真相', date: '2023-09-07' },
      { id: 6, title: '第6话 黎明', date: '2023-09-14' },
    ],
  },
  {
    id: 4,
    title: '第十三个房间',
    author: '郑秀贤',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20mystery%20cover%20illustration%20showing%20a%20dimly%20lit%20old%20mansion%20corridor%20with%20thirteen%20doors%2C%20eerie%20atmosphere%20with%20faint%20shadows%2C%20Korean%20webtoon%20art%20style%2C%20psychological%20thriller%20vibe%2C%20muted%20dark%20tones%2C%20suspenseful%20composition&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: 'suspense',
    description: '一座古老的宅邸里，有着十三个房间。每个房间都隐藏着不为人知的秘密。当侦探林秀雅接手调查一桩离奇失踪案时，她发现这十三个房间之间存在着令人毛骨悚然的联系。真相远比想象中更加可怕。',
    tags: ['悬疑', '推理', '惊悚', '心理'],
    rating: 4.6,
    views: 1560000,
    status: '连载中' as const,
    updateDate: '2026-08-03',
    chapters: [
      { id: 1, title: '第1话 宅邸', date: '2025-09-01' },
      { id: 2, title: '第2话 第一扇门', date: '2025-09-08' },
      { id: 3, title: '第3话 失踪者', date: '2025-09-15' },
      { id: 4, title: '第4话 线索', date: '2025-09-22' },
      { id: 5, title: '第5话 第七扇门', date: '2025-09-29' },
    ],
  },
  {
    id: 5,
    title: '社长大人请住手',
    author: '尹瑞妍',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20romantic%20comedy%20cover%20illustration%20featuring%20a%20handsome%20CEO%20in%20a%20suit%20and%20a%20cheerful%20female%20office%20worker%20in%20a%20funny%20awkward%20moment%2C%20bright%20office%20setting%2C%20Korean%20webtoon%20art%20style%2C%20lighthearted%20humorous%20tone%2C%20warm%20vibrant%20colors&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: 'comedy',
    description: '新入职的小职员李多惠万万没想到，她的顶头上司居然是自己大学时期的死对头！高冷社长vs元气少女，办公室里的爆笑日常就此拉开帷幕。从互相看不顺眼到暗生情愫，这段职场恋曲笑料百出。',
    tags: ['搞笑', '办公室', '恋爱', '喜剧'],
    rating: 4.5,
    views: 980000,
    status: '连载中' as const,
    updateDate: '2026-08-04',
    chapters: [
      { id: 1, title: '第1话 入职', date: '2025-11-01' },
      { id: 2, title: '第2话 重逢', date: '2025-11-08' },
      { id: 3, title: '第3话 加班', date: '2025-11-15' },
      { id: 4, title: '第4话 团建', date: '2025-11-22' },
      { id: 5, title: '第5话 出差', date: '2025-11-29' },
      { id: 6, title: '第6话 醉酒', date: '2025-12-06' },
      { id: 7, title: '第7话 真心', date: '2025-12-13' },
    ],
  },
  {
    id: 6,
    title: '重生之医道至尊',
    author: '韩正宇',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20drama%20cover%20illustration%20of%20a%20brilliant%20doctor%20in%20traditional%20Korean%20medical%20attire%20with%20golden%20acupuncture%20needles%20floating%20around%2C%20ancient%20Korean%20palace%20background%2C%20Korean%20webtoon%20art%20style%2C%20elegant%20regal%20atmosphere%2C%20golden%20lighting&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: 'drama',
    description: '现代顶尖外科医生韩宇在一次手术意外中重生到了古代朝鲜。凭借超越时代千年的医学知识，他在古代医学界掀起了一场革命。济世救人的同时，他也被卷入了一场关于皇权与医道的巨大阴谋之中。',
    tags: ['剧情', '重生', '医学', '古风'],
    rating: 4.9,
    views: 3200000,
    status: '连载中' as const,
    updateDate: '2026-08-05',
    chapters: [
      { id: 1, title: '第1话 重生', date: '2024-12-01' },
      { id: 2, title: '第2话 医术', date: '2024-12-08' },
      { id: 3, title: '第3话 扬名', date: '2024-12-15' },
      { id: 4, title: '第4话 危机', date: '2024-12-22' },
      { id: 5, title: '第5话 阴谋', date: '2024-12-29' },
      { id: 6, title: '第6话 反击', date: '2025-01-05' },
      { id: 7, title: '第7话 抉择', date: '2025-01-12' },
      { id: 8, title: '第8话 使命', date: '2025-01-19' },
    ],
  },
  {
    id: 7,
    title: '夜幕降临之时',
    author: '崔恩珠',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20horror%20cover%20illustration%20with%20a%20terrified%20girl%20looking%20back%20over%20her%20shoulder%20in%20a%20dark%20alley%2C%20ghostly%20figure%20in%20the%20shadows%2C%20Korean%20webtoon%20art%20style%2C%20chilling%20atmosphere%2C%20cold%20blueish%20dark%20tones%2C%20psychological%20horror%20vibe&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: 'horror',
    description: '每当夜幕降临，小镇上就会出现诡异的现象。镜子里的倒影开始微笑，走廊尽头传来脚步声，而所有人都声称看到了已经死去的人。七个高中生的命运，在这个被诅咒的小镇上紧紧交织在一起。',
    tags: ['恐怖', '惊悚', '灵异', '校园'],
    rating: 4.4,
    views: 1120000,
    status: '已完结' as const,
    updateDate: '2026-06-15',
    chapters: [
      { id: 1, title: '第1话 镜子', date: '2025-06-01' },
      { id: 2, title: '第2话 脚步声', date: '2025-06-08' },
      { id: 3, title: '第3话 归来的她', date: '2025-06-15' },
      { id: 4, title: '第4话 诅咒', date: '2025-06-22' },
      { id: 5, title: '第5话 真相', date: '2025-06-29' },
      { id: 6, title: '第6话 黎明', date: '2025-07-06' },
    ],
  },
  {
    id: 8,
    title: '我们的青涩时光',
    author: '柳智敏',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20school%20life%20cover%20illustration%20of%20two%20high%20school%20students%20sitting%20on%20a%20classroom%20windowsill%20during%20sunset%2C%20cherry%20blossoms%20outside%2C%20Korean%20webtoon%20art%20style%2C%20warm%20nostalgic%20atmosphere%2C%20soft%20golden%20evening%20light%2C%20youthful%20romantic%20aesthetic&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: 'school',
    description: '高中三年，是每个人生命中最美好的时光。四个性格迥异的女孩在同一间教室里相遇，她们一起笑过、哭过、争吵过，也在彼此的陪伴中慢慢成长。这是一部关于友情、梦想与青春的真实故事。',
    tags: ['校园', '友情', '青春', '成长'],
    rating: 4.7,
    views: 1450000,
    status: '连载中' as const,
    updateDate: '2026-08-02',
    chapters: [
      { id: 1, title: '第1话 开学', date: '2025-08-20' },
      { id: 2, title: '第2话 同桌', date: '2025-08-27' },
      { id: 3, title: '第3话 社团', date: '2025-09-03' },
      { id: 4, title: '第4话 考试', date: '2025-09-10' },
      { id: 5, title: '第5话 文化祭', date: '2025-09-17' },
      { id: 6, title: '第6话 修学旅行', date: '2025-09-24' },
    ],
  },
  {
    id: 9,
    title: '天命皇后',
    author: '张艺琳',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20historical%20romance%20cover%20illustration%20of%20a%20beautiful%20queen%20in%20elaborate%20traditional%20Korean%20hanbok%20standing%20in%20royal%20palace%2C%20Korean%20webtoon%20art%20style%2C%20elegant%20regal%20atmosphere%2C%20intricate%20fabric%20details%2C%20soft%20romantic%20lighting&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    category: 'drama',
    description: '出身平凡的少女被选入宫中，本以为只是一场政治婚姻，却没想到命运的齿轮早已开始转动。在后宫的尔虞我诈中，她凭借智慧与勇气一步步走向权力巅峰，成为了一代传奇皇后。',
    tags: ['剧情', '古风', '宫斗', '权谋'],
    rating: 4.8,
    views: 2780000,
    status: '连载中' as const,
    updateDate: '2026-08-05',
    chapters: [
      { id: 1, title: '第1话 入选', date: '2025-01-15' },
      { id: 2, title: '第2话 宫廷', date: '2025-01-22' },
      { id: 3, title: '第3话 暗流', date: '2025-01-29' },
      { id: 4, title: '第4话 交锋', date: '2025-02-05' },
      { id: 5, title: '第5话 逆转', date: '2025-02-12' },
      { id: 6, title: '第6话 册封', date: '2025-02-19' },
      { id: 7, title: '第7话 治国', date: '2025-02-26' },
    ],
  },
  {
    id: 10,
    title: '无敌从签到开始',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20action%20fantasy%20cover%20illustration%20of%20a%20young%20man%20with%20supernatural%20glowing%20aura%20surrounded%20by%20floating%20system%20interface%20screens%2C%20Korean%20webtoon%20art%20style%2C%20dynamic%20action%20pose%2C%20digital%20holographic%20effects%2C%20futuristic%20elements&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    category: 'fantasy',
    description: '普通大学生金俊秀意外获得了一个神秘系统，每天签到就能获得超凡能力。力量、速度、智力全面提升，从此开启了他开挂般的人生。但随之而来的，是隐藏在系统背后关乎世界存亡的巨大秘密。',
    tags: ['奇幻', '系统', '升级', '热血'],
    rating: 4.6,
    views: 1980000,
    status: '连载中' as const,
    updateDate: '2026-08-04',
    chapters: [
      { id: 1, title: '第1话 系统', date: '2025-04-01' },
      { id: 2, title: '第2话 初始', date: '2025-04-08' },
      { id: 3, title: '第3话 升级', date: '2025-04-15' },
      { id: 4, title: '第4话 试炼', date: '2025-04-22' },
      { id: 5, title: '第5话 变强', date: '2025-04-29' },
    ],
  },
  {
    id: 11,
    title: '恋爱DNA',
    author: '林允儿',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20romance%20cover%20illustration%20of%20a%20couple%20holding%20hands%20under%20cherry%20blossom%20trees%20in%20spring%2C%20pink%20petals%20falling%2C%20Korean%20webtoon%20art%20style%2C%20soft%20romantic%20atmosphere%2C%20gentle%20pastel%20colors%2C%20dreamy%20springtime%20aesthetic&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    category: 'love',
    description: '科学家发现了一种神奇的恋爱DNA，拥有相同DNA序列的人注定会相爱。当不相信爱情的生物学家苏敏遇到了命中注定的他，科学的理性与感性的冲动在她心中激烈碰撞。一段科学与爱情的奇妙邂逅就此展开。',
    tags: ['恋爱', '科幻', '甜宠', '职业'],
    rating: 4.7,
    views: 1670000,
    status: '连载中' as const,
    updateDate: '2026-08-03',
    chapters: [
      { id: 1, title: '第1话 发现', date: '2025-07-01' },
      { id: 2, title: '第2话 匹配', date: '2025-07-08' },
      { id: 3, title: '第3话 相遇', date: '2025-07-15' },
      { id: 4, title: '第4话 实验', date: '2025-07-22' },
      { id: 5, title: '第5话 心动', date: '2025-07-29' },
    ],
  },
  {
    id: 12,
    title: '异世界美食家',
    author: '朴尚宇',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20comedy%20fantasy%20cover%20illustration%20of%20a%20cheerful%20chef%20in%20a%20fantasy%20world%20holding%20delicious%20dishes%20surrounded%20by%20magical%20creatures%2C%20Korean%20webtoon%20art%20style%2C%20bright%20vibrant%20colors%2C%20whimsical%20atmosphere%2C%20food%20illustration%20details&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    category: 'comedy',
    description: '米其林三星主厨意外穿越到剑与魔法的异世界！在这个连盐都稀缺的世界里，现代美食成了他的最强武器。用料理征服龙族、用甜点打动精灵公主、用火锅收服兽人军团——异世界的美食革命，现在开始！',
    tags: ['搞笑', '穿越', '美食', '奇幻'],
    rating: 4.8,
    views: 2340000,
    status: '连载中' as const,
    updateDate: '2026-08-05',
    chapters: [
      { id: 1, title: '第1话 穿越', date: '2025-05-01' },
      { id: 2, title: '第2话 第一餐', date: '2025-05-08' },
      { id: 3, title: '第3话 龙族来客', date: '2025-05-15' },
      { id: 4, title: '第4话 精灵之森', date: '2025-05-22' },
      { id: 5, title: '第5话 美食大赛', date: '2025-05-29' },
      { id: 6, title: '第6话 兽人部落', date: '2025-06-05' },
    ],
  },
];

export const testimonials = [
  {
    id: 1,
    name: '小猫咪爱吃鱼',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20girl%20avatar%20with%20cat%20ears%2C%20Korean%20webtoon%20style%2C%20simple%20clean%20background%2C%20soft%20cute%20expression&width=80&height=80&seq=avatar-01&orientation=squarish',
    comment: '韩漫之家的资源真的太全了！找了好久的那部冷门韩漫居然在这里找到了，画质也是超高清的，下拉式阅读体验太流畅了，强烈推荐！',
    rating: 5,
    date: '2026-07-28',
  },
  {
    id: 2,
    name: '深夜读书人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cool%20anime%20style%20boy%20avatar%20with%20glasses%2C%20Korean%20webtoon%20style%2C%20simple%20clean%20background%2C%20calm%20expression&width=80&height=80&seq=avatar-02&orientation=squarish',
    comment: '每天睡前必刷的网站，更新速度很快，而且完全免费。最喜欢那个"已完结"的分类，可以一口气看完不用等更新，太爽了！',
    rating: 5,
    date: '2026-07-25',
  },
  {
    id: 3,
    name: '漫迷小丸子',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20girl%20avatar%20with%20pink%20hair%2C%20Korean%20webtoon%20style%2C%20simple%20clean%20background%2C%20happy%20smile&width=80&height=80&seq=avatar-03&orientation=squarish',
    comment: '从朋友那里知道这个平台的，一开始只是试试看，结果一发不可收拾！页面设计也很漂亮，分类清晰，找漫画特别方便。韩漫之家yyds！',
    rating: 5,
    date: '2026-07-20',
  },
  {
    id: 4,
    name: '追漫达人Lee',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylish%20anime%20style%20boy%20avatar%20with%20cool%20hair%2C%20Korean%20webtoon%20style%2C%20simple%20clean%20background%2C%20confident%20expression&width=80&height=80&seq=avatar-04&orientation=squarish',
    comment: '追了三年韩漫了，国内大大小小的平台都用过，韩漫之家的阅读体验绝对是一流的。高清画质、加载速度快、没有任何广告弹窗，这才是良心网站。',
    rating: 5,
    date: '2026-07-18',
  },
  {
    id: 5,
    name: '小月亮',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20girl%20avatar%20with%20long%20dark%20hair%2C%20Korean%20webtoon%20style%2C%20simple%20clean%20background%2C%20gentle%20smile&width=80&height=80&seq=avatar-05&orientation=squarish',
    comment: '这个网站的分类功能太贴心了，按恋爱、奇幻、动作分得清清楚楚，还能看到每部作品的评分和热度，选漫再也不纠结了！而且全都是免费的，良心到哭。',
    rating: 4,
    date: '2026-07-15',
  },
  {
    id: 6,
    name: '书虫阿泽',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cool%20anime%20style%20boy%20avatar%20wearing%20hoodie%2C%20Korean%20webtoon%20style%2C%20simple%20clean%20background%2C%20friendly%20expression&width=80&height=80&seq=avatar-06&orientation=squarish',
    comment: '韩漫的更新速度真的没话说，基本上能和韩国同步。而且每一话的质量都特别高，画质清晰得不得了。已经推荐给身边所有喜欢韩漫的朋友了！',
    rating: 5,
    date: '2026-07-10',
  },
];

export const faqs = [
  {
    question: '韩漫之家是免费的吗？',
    answer: '是的，韩漫之家作为专业在线免费韩漫阅读平台，所有漫画内容完全免费提供给用户阅读。我们致力于让每一位韩漫爱好者都能免费享受高品质的韩国漫画阅读体验，无需支付任何费用。',
  },
  {
    question: '网站上的韩漫是高清画质吗？',
    answer: '绝对高清！我们平台上的每一部韩国漫画都采用高清画质呈现，支持下拉式阅读模式，让您享受流畅、清晰的阅读体验。无论是人物细节还是场景描绘，都能完美展现韩漫的精美画风。',
  },
  {
    question: '韩漫之家的更新速度如何？',
    answer: '我们尽最大努力保持与韩国同步更新。热门连载作品通常会在韩国更新后的24-48小时内同步上线，让您第一时间阅读到最新的韩漫内容。',
  },
  {
    question: '如何使用韩漫之家的分类功能？',
    answer: '在首页顶部或导航栏中，您可以找到分类入口。我们提供了恋爱、奇幻、动作、悬疑、搞笑、剧情、恐怖、校园等多个分类，点击任意分类即可浏览该类型下的全部韩漫作品。',
  },
  {
    question: '可以在手机上阅读吗？',
    answer: '当然可以！韩漫之家完美适配手机、平板和电脑等多种设备。在手机上阅读时，我们特别优化了下拉式阅读体验，让您随时随地都能享受韩漫的乐趣。',
  },
  {
    question: '如何找到已完结的韩漫作品？',
    answer: '在漫画列表页面中，您可以通过筛选功能选择"已完结"状态，即可查看所有已完结的韩漫作品。这些作品可以一口气看到结局，不用担心追更的烦恼。',
  },
];